"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TBlockCtor = exports.default = void 0;
var _HTMLContentModel = _interopRequireDefault(require("../model/HTMLContentModel"));
var _TNodeCtor = _interopRequireDefault(require("./TNodeCtor"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TBlockCtor = function TBlock(init) {
  this.initialize(init);
}; //@ts-ignore

exports.TBlockCtor = TBlockCtor;
TBlockCtor.prototype = new _TNodeCtor.default('block', 'TBlock');
TBlockCtor.prototype.matchContentModel = function matchContentModel(contentModel) {
  return contentModel === _HTMLContentModel.default.block || contentModel === _HTMLContentModel.default.mixed;
};
TBlockCtor.prototype.collapseChildren = function collapseChildren() {
  var indexesToSplice = [];
  this.children.forEach(function (child, i) {
    child.collapse();
    if (child.isEmpty()) {
      indexesToSplice.push(i);
    }
  });
  this.spliceChildren(indexesToSplice);
};
TBlockCtor.prototype.getNativeStyles = function getNativeStyles() {
  if (this.__nativeStyles === false) {
    this.__nativeStyles = _objectSpread(_objectSpread({}, this.styles.nativeBlockFlow), this.styles.nativeBlockRet);
  }
  return this.__nativeStyles;
};
var _default = TBlockCtor;
exports.default = _default;